import React from 'react';

const OverviewMetricCard = React.memo(({ label, value, valueClassName }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className={`text-2xl font-bold ${valueClassName}`}>{value}</div>
      <div className="text-sm text-gray-600">{label}</div>
    </div>
  );
});

export default OverviewMetricCard;
